import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useBoolean } from '@fluentui/react-hooks';
import { Mail16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

// models
import { EmailViewModel } from '../../../models/Entities/Person/Email/EmailModels';

// components
import PersonEmailFormComponent from './PersonEmail.Form.Component';
import { PersonContactList } from '../PersonContactList/PersonContactList.Component';

// functions
import * as ComponentFunctions from './PersonEmails.List.Functions';

/** Correos de la persona: grupo compacto de la tarjeta de contacto, con alta, edición y baja. */
const PersonEmailsListComponent = (props: ComponentFunctions.Props) => {
  const [t] = useTranslation();
  const [isFormOpen, { setTrue: openForm, setFalse: dismissForm }] = useBoolean(false);
  const [selectedEmailId, setSelectedEmailId] = useState<number | undefined>(undefined);

  const load = () => { if (props.PersonId) props.GetEmailsByPersonId(props.PersonId); };
  useEffect(() => { load(); }, [props.PersonId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PersonContactList<EmailViewModel>
        testId="person-emails"
        title={t('persons.emails.list.count', { defaultValue: 'Correos' })}
        icon={<Mail16Regular />}
        items={props.emails}
        primary={(email) => email.email || '—'}
        secondary={(email) => email.comments || undefined}
        itemLabel={(email) => email.email || ''}
        isLoading={props.isLoading}
        failOnLoading={props.failOnLoading}
        isDeleting={props.isDeleting}
        failOnDeleting={props.failOnDeleting}
        error={props.error}
        addLabel={t('persons.emails.list.add', { defaultValue: 'Agregar correo' })}
        emptyText={t('persons.emails.list.empty', { defaultValue: 'No hay correos registrados' })}
        loadingLabel={t('persons.emails.list.loading', { defaultValue: 'Cargando correos...' })}
        loadErrorTitle={t('persons.emails.list.error', { defaultValue: 'No fue posible obtener los correos' })}
        deleteTitle={t('persons.emails.list.deleteTitle', { defaultValue: 'Eliminar correo' })}
        deleteText={(email) => t('persons.emails.list.deleteText', { defaultValue: 'Se va a eliminar el correo {{email}}. Esta acción no se puede deshacer.', email: email.email })}
        onAdd={() => { setSelectedEmailId(undefined); openForm(); }}
        onEdit={(email) => { setSelectedEmailId(email.id); openForm(); }}
        onDelete={(email) => props.DeleteEmail(email.id)}
        onRetry={load}
      />
      <PersonEmailFormComponent
        isOpen={isFormOpen}
        openPanel={openForm}
        dismissPanel={() => { setSelectedEmailId(undefined); dismissForm(); }}
        PersonId={props.PersonId}
        emailId={selectedEmailId}
      />
    </>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(PersonEmailsListComponent as any);
